<script>
  import { setContext } from "svelte";
  export let header = "";

  export let parentId = `accordion-${Math.random().toString(36).slice(2, 9)}`;

  setContext("accordion", {
    getParent: () => parentId,
    getHeader: () => header,
  });
</script>

{#if $$props.title == undefined}
  <p
    class="fs-5 bg-primary-subtle text-light-emphasis mb-0 p-2 border-bottom text-center fw-light"
  >
    Frequently Asked Questions
  </p>
{:else if $$props.title.length > 0}
  <p
    class="fs-5 bg-dark-subtle text-light-emphasis mb-0 p-2 border-bottom text-center fw-light"
  >
    {$$props.title}
  </p>
{/if}

{#if $$props.title != undefined && $$props.title === false}
  <slot />
{:else}
  <div class="accordion accordion-flush" id={parentId}>
    <slot />
  </div>
{/if}
